import { t } from 'i18next';
import { html, nothing } from 'lit';
import { deleteApiAbsoluteURL } from '../../../utils/fetcher';
import { updateEvent } from '../../../utils/updateEvent';
import { Reply } from './Reply';
export const DeleteReply = ({ showModal, setShowModal, reply, isSeller, feedbackGiven, showDeleteButton, token }) => {
    return html `
    <div>
      <trust-modal
        ?show="${showModal}"
        confirmText="${t('Delete')}"
        @confirm="${() => {
        deleteAnswer(reply._links.self.href, token);
    }}"
        destructive
        @cancel="${() => setShowModal(false)}"
      >
        <div class="w-full md:w-[600px]">
          <h3 class="mt-0">${t('Delete')} ${t('Reply').toLowerCase()}</h3>
          ${Reply({ reply, feedbackGiven, isReplierSeller: !isSeller })}
        </div>
      </trust-modal>

      ${!feedbackGiven && showDeleteButton
        ? html `<div class="flex justify-end">
            <trust-button
              dataTest="delete reply"
              small
              quiet
              destructive
              @click=${() => {
            setShowModal(true);
        }}
              >${t('Delete')} ${t('Reply').toLowerCase()}
            </trust-button>
          </div>`
        : nothing}
    </div>
  `;
};
const deleteAnswer = async (url, token) => {
    await deleteApiAbsoluteURL(url, token);
    window.dispatchEvent(updateEvent);
};
//# sourceMappingURL=DeleteReply.js.map